<template>
    <div class="skeleton" :style="{width, height}"></div>
</template>

<script setup lang="ts">
    withDefaults(
        defineProps<{
            height?: string;
            width?: string;
        }>(),
        {
            height: '44px',
            width: '100%',
        },
    );
</script>

<style lang="scss" scoped>
    .skeleton {
        overflow: hidden;
        position: relative;
        background-color: var(--joy-color-secondary-10);
        width: 100%;
        height: 44px;
        border-radius: var(--joy-core-radius-3);

        &::after {
            content: '';
            transform: translateX(100%);
            width: 100%;
            height: 100%;
            position: absolute;
            z-index: 1;
            animation: slide 0.8s infinite linear;
            background-image: linear-gradient(
                to right,
                rgb(255 255 255 / 0%) 0%,
                rgb(255 255 255 / 80%) 50%,
                rgb(128 186 232 / 0%) 99%,
                rgb(125 185 232 / 0%) 100%
            );
        }
    }

    @keyframes slide {
        0% {
            transform: translateX(-100%);
        }

        100% {
            transform: translateX(100%);
        }
    }
</style>
